import _ from 'lodash';
import callApi from '../../util/apiCaller';
// import {userNotify} from '../../components/Toasts/ToastAdd';

export const FETCHING_VENUE_EXPERT_PAGE = 'FETCHING_VENUE_EXPERT_PAGE';
export const FETCH_VENUE_EXPERT_PAGE = 'FETCH_VENUE_EXPERT_PAGE';
export const LOADING_MORE_VENUELIST_EXPERT_PAGE = 'LOADING_MORE_VENUELIST_EXPERT_PAGE';
export const LOAD_MORE_VENUELIST_EXPERT_PAGE = 'LOAD_MORE_VENUELIST_EXPERT_PAGE';

export function showLoaderForVenueExpertLoading(val) {
  return {
    type: FETCHING_VENUE_EXPERT_PAGE,
    isLoadingPage: val
  };
}

export function loadVenueExpert(data) {
  return {
    type: FETCH_VENUE_EXPERT_PAGE,
    venueexpert: data.venueexpert,
    isLoadingPage: false,
    pageNum: 1,
    totalCount: data.totalCount,
    isFetchingVenues: false,
    venueList: data.venueList,
  };
}

export function fetchVenueExpert(url) {
  return (dispatch) => {
    dispatch(showLoaderForVenueExpertLoading(true));
    return callApi(`venueexpert/${url}`, 'GET')
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadVenueExpert(res.data));
        } else {
          dispatch(showLoaderForVenueExpertLoading(false));
          // dispatch(userNotify('Failed to load event info, please try again', 'error'));
        }
      });
  };
}

export function showLoaderForFetchingVenueList(val) {
  return {
    type: LOADING_MORE_VENUELIST_EXPERT_PAGE,
    isFetchingVenues: val
  };
}

export function loadVenueExpertVenueList(data, pageNum) {
  return {
    type: LOAD_MORE_VENUELIST_EXPERT_PAGE,
    pageNum: pageNum,
    totalCount: data.totalCount,
    isFetchingVenues: false,
    venueList: data.venueList,
  };
}

export function fetchVenueExpertVenueList(id, filters) {
  return (dispatch) => {
    dispatch(showLoaderForFetchingVenueList(true));
    return callApi(`venueexpert/${id}/venue-list`, 'post', filters)
      .then(res => {
        if (res.status === 'Success') {
          dispatch(loadVenueExpertVenueList(res.data, filters.pageNum));
        } else {
          dispatch(showLoaderForFetchingVenueList(false));
          // dispatch(userNotify('Failed to load event info, please try again', 'error'));
        }
      });
  };
}
